module.exports = __webpack_public_path__ + "img/email.4661b922.svg";